/**
 * Polyfills
 */
import 'es6-promise/auto'

/**
 * Main Vue Files.
 */
import Vue from 'vue'
import App from './App'
import router from './router'
import store from 'vx/store'
import './utils/filters'

/**
 * Dependencies
 */
import 'jquery'
import 'bootstrap'
import 'bootstrap-drawer/dist/js/drawer'
import 'utils/validation'
import 'directives'

Vue.config.productionTip = false

Vue.prototype.$bus = new Vue()

/**
 * Google Maps
 */
import * as GoogleMaps from 'vue2-google-maps'

Vue.use(GoogleMaps, {
  load: {
    key: 'AIzaSyCopqpnuyAT0VuMaoS1iht5sGGQVo8lT6c',
    libraries: ['places', 'geometry']
  }
})

import Raven from 'raven-js'
Raven.config('https://1d4ad603e6274bf28d42a14a622c6ad2@bugs.codium.com.au/36').install()

/**
 * Create the Vue Application
 */
const VueApp = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

export default VueApp



// WEBPACK FOOTER //
// ./src/main.js